module.exports = __webpack_public_path__ + "exo-latin-200.9154b96a4e182f3f6027.svg";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/typeface-exo/files/exo-latin-200.svg
// module id = ../../../../typeface-exo/files/exo-latin-200.svg
// module chunks = styles